export default "__VITE_ASSET__252a2969__"